package at.apa.statistictracker.logger

internal actual class PlatformLogger {
    actual var enabled = true

    actual fun v(tag: String, message: String) {
        println("💬 ($tag) $message")
    }

    actual fun d(tag: String, message: String) {
        println("🕵️ ($tag) $message")
    }

    actual fun i(tag: String, message: String) {
        println("ℹ️ ($tag) $message")
    }

    actual fun w(tag: String, message: String) {
        println("⚠️ ($tag) $message")
    }

    actual fun e(tag: String, message: String) {
        println("☢️ ($tag) $message")
    }

    actual fun e(tag: String, message: String, throwable: Throwable) {
        println("☢️ ($tag) $message - exception: $throwable")
    }
}

